import { createUseStyles } from "react-jss";
import { pxToRem } from "@/util/common";

const useCommonFormStyles = createUseStyles({
	formWrap: {
		padding: {
			top: pxToRem(10),
			left: pxToRem(20),
			right: pxToRem(20),
		},
	},
	labelTitle: {
		display: "flex",
		alignItems: "center",
		color: "#FFFFFF",
		fontFamily: "Noto Sans SC",
		fontSize: pxToRem(14),
		fontWeight: 500,
		padding: {
			top: pxToRem(10),
			bottom: pxToRem(10),
		},
		"&.warn": {
			"& .icon": {
				width: pxToRem(20),
				height: pxToRem(20),
				marginRight: pxToRem(6),
			},
		},
		"& .remaining": {
			flex: 1,
			textAlign: "right",
			"& span": {
				color: "#868FA8",
			},
		},
	},
	inputWrap: {
		display: "flex",
		alignItems: "center",
		border: "1px solid #4C66C74D",
		backgroundColor: "#181A22",
		borderRadius: pxToRem(8),
		height: pxToRem(46),
		padding: {
			left: pxToRem(10),
			right: pxToRem(6),
		},
		"&.focus": {
			borderColor: "#4C66C7",
		},
		"&.warn": {
			borderColor: "#FF6161",
		},
		"& .icon": {
			width: pxToRem(24),
			height: pxToRem(24),
			marginRight: pxToRem(9),
		},
	},
	input: {
		flex: 1,
		height: "100%",
		"--color": "#fff",
	},
	selector: {
		display: "flex",
		alignItems: "center",
		flex: 1,
		overflow: "hidden",
		color: "#FFFFFF",
		fontSize: pxToRem(16),
		fontWeight: 600,
		paddingRight: pxToRem(10),
		"& span": {
			flex: 1,
			overflow: "hidden",
		},
	},
	maxButton: {
		"--border-style": "none",
		borderRadius: pxToRem(18),
		width: pxToRem(60),
		height: pxToRem(28),
		fontWeight: 500,
		fontSize: pxToRem(14),
		color: "#fff",
		fontFamily: "Noto Sans SC",
		background: "linear-gradient(90deg, #4675FF 0%, #0E329D 100%)",
	},

	submit: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		height: pxToRem(50),
		fontSize: pxToRem(14),
		fontWeight: "500",
		fontFamily: "Noto Sans SC",
		"--text-color": "#FFFFFF",
		"--border-width": "0",
		margin: {
			top: pxToRem(20),
		},
		background: "linear-gradient(90deg, #4675FF 0%, #0E329D 100%)",
		boxShadow:
			"0px 10px 10px 1px #184DED4D, 0px 2px 4px 0px #00C2FF40 inset",
		"& .icon": {
			width: pxToRem(20),
			height: pxToRem(20),
		},
	},
});
export default useCommonFormStyles;
